import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Copy, Flex, Box, Button } from '@elparking/components'
import styled from 'styled-components'
import { TRADENAME } from 'commons/js/constants'
const Container = styled(Box)`
    background-size: 150% 250%;
    background-position-y: 70%;
    background-image: url('/images/rental-car/banner-background.webp');
`
const DNIWarning = ({onClick}) =>
    <Container display='inline-block' width='100%' padding='1em' margin='1em 0em'>
        <Flex flexDirection='column'>
            <Copy fontWeight='bold' fontColor='accent_dark' fontSize='small' padding='0'>
                <FormattedMessage defaultMessage='¿Tienes productos contratados con el grupo Mutua?'/>
            </Copy>
            <Copy fontSize='xxSmall' fontWeight='regular'>
                <FormattedMessage
                  defaultMessage='Introduce tu DNI para consultar y gestionar tus productos de {tradename} directamente. {link}'
                  values={{
                    link: <Button.unstyled fontColor='main' fontSize='xxSmall' onClick={onClick}><FormattedMessage defaultMessage='Introducir mi DNI'/></Button.unstyled>,
                    tradename: TRADENAME,
                  }}/>
            </Copy>
        </Flex>
    </Container>

DNIWarning.propTypes = {
    onClick: PropTypes.func,
}

export default DNIWarning
